import _regeneratorRuntime from 'babel-runtime/regenerator';
import _extends from 'babel-runtime/helpers/extends';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import { GrantType, PlanType } from '@/common/permission';
import { fetchGmakerTemplateList } from '@/api/gmaker/template';
import { rechargeTypeChannels } from '../config';
import _ from 'lodash';

export default {
  props: {
    formValue: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      default: 'create'
    }
  },
  data: function data() {
    return {
      templateList: [],
      optionChannels: [],
      checkedAllChannel: '',
      GrantType: GrantType
    };
  },

  computed: {
    planTypeOptionChannels: function planTypeOptionChannels() {
      if (this.formValue.type === PlanType.Recharge) {
        return this.optionChannels.filter(function (t) {
          return rechargeTypeChannels.includes(t.id);
        });
      }

      return this.optionChannels;
    }
  },
  methods: {
    getTemplateList: function getTemplateList(params) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchGmakerTemplateList(_extends({}, params, { is_active: 1 }));

              case 2:
                res = _context.sent;

                _this.templateList = (_.get(res, 'data.data.list') || []).map(function (item) {
                  return _extends({}, item, {
                    value: item.id,
                    label: item.name
                  });
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getOptionChannels: function getOptionChannels() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var useCache, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                useCache = true;
                _context2.next = 3;
                return _this2.$store.dispatch('config/getCommonConfig', {
                  useCache: useCache,
                  names: ['channels']
                });

              case 3:
                res = _context2.sent;

                _this2.optionChannels = (_.get(res, 'channels') || []).map(function (item) {
                  return _extends({}, item, {
                    value: item.id,
                    label: item.name
                  });
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    selectAll: function selectAll() {
      var _this3 = this;

      this.$nextTick(function () {
        if (_this3.checkedAllChannel) {
          // eslint-disable-next-line vue/no-mutating-props
          _this3.formValue.channel_ids = _this3.planTypeOptionChannels.map(function (item) {
            return item.id;
          });
        } else {
          // eslint-disable-next-line vue/no-mutating-props
          _this3.formValue.channel_ids = [];
        }
      });
    },
    checkDisabled: function checkDisabled(type) {
      return this.action === 'update' && this.formValue.type === PlanType.Recharge;
    }
  },

  created: function created() {
    this.getOptionChannels();
    this.getTemplateList();
  }
};